import React from 'react';

interface ClearAllLinkProps {
  onClick: () => void;
}

const ClearAllLink = ({ onClick }: ClearAllLinkProps) => {
  return (
    <a
      className="cursor-pointer topic-filter__clear_all inline-block text-[#3722D3] font-bold text-[14px] leading-[16px]"
      title="Clear all"
      onClick={onClick}
    >
      Clear All
    </a>
  );
};
export default ClearAllLink;
